exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".c-template-block {\n  position: absolute; }\n  .app--debug .c-template-block {\n    border: 1px solid #c00; }\n\n.c-template-block__content {\n  position: absolute;\n  width: 100%;\n  height: 100%; }\n\n.c-template-block__title {\n  font-weight: bold; }\n\n.c-template-block__debug {\n  position: absolute;\n  padding: 4px;\n  background-color: #c00;\n  color: #fff; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/template-block/template-block.scss
// module id = 661
// module chunks = 0